"use strict";

exports.__esModule = true;
exports.default = groupify;

function groupify(slug, group) {
  const parts = [];

  if (group) {
    parts.push(group);
  }

  parts.push(slug);
  return `/${parts.join("/")}`;
}